import store from '@/store';
import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from '@vue/composition-api';

import useDate from '@/utils/hooks/useDate';
import usePagination from '@/views/components/pagination/usePagination';
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal';

import reportModel from '@/models/report/report';

export default function useHistoryReport() {
  const vm = getCurrentInstance().proxy;

  const {
    resolveDateWithSeperator,
    resolveDateWithComparator,
    resolveDate,
  } = useDate();

  const { pagination ,onFilterEntity,onPageChange } = usePagination();

  const { openDefaultErrorModal, openWarningModal } = useValidationModal();

  const { fetchFileListModel, removeReportModel } = reportModel();

  const loading = reactive({ tableData: false });

  const historyReportList = ref([]);

  const keyChange = ref(0);

  const fields = [
    { key: 'report_seq', label: 'No.' },
    { key: 'report_name', label: 'Report' },
    { key: 'filter', label: 'Filter' },
    { key: 'date_time', label: 'Date Time' },
    { key: 'updatedtime', label: 'Last Update' },
    { key: 'progress', label: 'Progress' },
    { key: 'status', label: 'Status' },
    { key: 'actions', label: '' },
  ];

  const fetchHistoryReport = (loadingEffect = true) => {
    fetchFileListModel.payload.page = pagination.currentPage;
    fetchFileListModel.payload.limit = pagination.perPage;

    if (loadingEffect) {
      loading.tableData = true;
    }

    store
      .dispatch('api/apiRequest', fetchFileListModel)
      .then((response) => {
        historyReportList.value = response.data.report_history_list;
        pagination.currentPage = response.data.current_page;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => (loading.tableData = false));
  };

  const deleteReport = (report) => {
    removeReportModel.payload.Report_Id = report.report_id;
    removeReportModel.payload.Report_Job_Id = report.report_job_id;
    report.loading = true;
    keyChange.value++;

    store
      .dispatch('api/apiRequest', removeReportModel)
      .then(() => {
        if (pagination.totalRows - 1 == 0) {
          return (pagination.currentPage = 1);
        }
        return fetchHistoryReport(false);
      })
      .finally(() => {
        report.loading = false;
        keyChange.value++;
      });
  };

  const onClickDownload = (link) => {
    const linkRef = vm.$refs[`download-${link}`];

    if (linkRef) {
      linkRef.click();
    }
  };

  const onClickDelete = (fileDetail) => {
    openWarningModal(
      'ลบ Report',
      `ต้องการลบ ${
        fileDetail.report_name ? `${fileDetail.report_name}` : 'report นี้'
      } หรือไม่`,
      () => deleteReport(fileDetail)
    );
  };

  onBeforeMount(() => {
    fetchHistoryReport();
  });

  watch(
    () => pagination,
    () => {
      if(!loading.tableData) {
        fetchHistoryReport();
      }
    },
    { deep: true }
  );

  return {
    fields,
    historyReportList,
    loading,
    pagination,
    keyChange,
    resolveDateWithSeperator,
    resolveDateWithComparator,
    resolveDate,
    onPageChange,
    onFilterEntity,
    onClickDownload,
    onClickDelete,
  };
}
